import React from 'react';

// Aligné sur SignedContractsTable : pastille fine, text-[9px], colors business.
// Le palier 0 est conservé en cas d'affichage hors-flow (ne devrait plus apparaître
// car le backend exclut désormais les comptes sans mandat).
const STYLE = {
  0:   { wrap: 'bg-red-50 text-red-700 ring-red-200',             dot: 'bg-red-500',     label: 'À connecter' },
  33:  { wrap: 'bg-orange-50 text-orange-700 ring-orange-200',    dot: 'bg-orange-500',  label: '1/3 fichiers reçus' },
  66:  { wrap: 'bg-yellow-50 text-yellow-700 ring-yellow-200',    dot: 'bg-yellow-500',  label: '2/3 fichiers reçus' },
  100: { wrap: 'bg-emerald-50 text-emerald-700 ring-emerald-200', dot: 'bg-emerald-500', label: 'Prêt à optimiser' },
};

// Style "partiel" : au niveau d'un compte parent, certains PDL prêts et d'autres pas.
// Ambre pour distinguer clairement du 0% (rouge) ou 100% (vert).
const PARTIAL_STYLE = { wrap: 'bg-amber-50 text-amber-700 ring-amber-200', dot: 'bg-amber-500' };

// Drapeaux ENEDIS illisibles (RPC en échec) : gris neutre, jamais « À connecter ».
const UNKNOWN_STYLE = { wrap: 'bg-gray-50 text-gray-600 ring-gray-200', dot: 'bg-gray-400' };

export default function PDLProgressBadge({ pct, label, partial = false, unknown = false }) {
  if (unknown) {
    return (
      <span
        title="Les données ENEDIS n'ont pas pu être lues : progression inconnue."
        className={`inline-flex items-center gap-1 rounded-full px-1.5 py-0.5 text-[9px] font-medium ring-1 ring-inset whitespace-nowrap ${UNKNOWN_STYLE.wrap}`}
      >
        <span className={`h-1 w-1 rounded-full ${UNKNOWN_STYLE.dot}`} aria-hidden />
        <span>Données ENEDIS indisponibles</span>
      </span>
    );
  }
  if (partial) {
    return (
      <span className={`inline-flex items-center gap-1 rounded-full px-1.5 py-0.5 text-[9px] font-medium ring-1 ring-inset whitespace-nowrap ${PARTIAL_STYLE.wrap}`}>
        <span className={`h-1 w-1 rounded-full ${PARTIAL_STYLE.dot}`} aria-hidden />
        <span>{label || 'Partiel'}</span>
      </span>
    );
  }
  const s = STYLE[pct] || STYLE[0];
  const text = label || s.label;
  return (
    <span className={`inline-flex items-center gap-1 rounded-full px-1.5 py-0.5 text-[9px] font-medium ring-1 ring-inset whitespace-nowrap ${s.wrap}`}>
      <span className={`h-1 w-1 rounded-full ${s.dot}`} aria-hidden />
      <span>{pct}% · {text}</span>
    </span>
  );
}
